import * as React from 'react';

interface Props {
  size?: number;
}

const InlineSpinner: React.FC<Props> = ({ size = 32 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 73 72"
      className="animate-spin"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.8873 36C69.9871 36 72.5447 33.4722 72.0633 30.41C71.6226 27.6061 70.8508 24.8577 69.7597 22.2234C67.9505 17.8557 65.2988 13.8871 61.9558 10.5442C58.6129 7.20125 54.6443 4.54951 50.2766 2.74034C47.6423 1.64916 44.8939 0.877377 42.09 0.436654C39.0278 -0.044683 36.5 2.51289 36.5 5.61271C36.5 8.71252 39.0442 11.1622 42.0648 11.8585C43.3995 12.1661 44.7095 12.5846 45.9808 13.1113C48.9866 14.3563 51.7177 16.1812 54.0183 18.4817C56.3188 20.7823 58.1437 23.5134 59.3887 26.5192C59.9154 27.7905 60.3339 29.1005 60.6415 30.4352C61.3378 33.4558 63.7875 36 66.8873 36Z"
        fill="#187A90"
      />
      <path
        opacity="0.3"
        d="M72.5 36C72.5 55.8823 56.3823 72 36.5 72C16.6177 72 0.5 55.8823 0.5 36C0.5 16.1177 16.6177 0 36.5 0C56.3823 0 72.5 16.1177 72.5 36ZM11.7254 36C11.7254 49.6826 22.8174 60.7746 36.5 60.7746C50.1826 60.7746 61.2746 49.6826 61.2746 36C61.2746 22.3174 50.1826 11.2254 36.5 11.2254C22.8174 11.2254 11.7254 22.3174 11.7254 36Z"
        fill="#187A90"
      />
    </svg>
  );
};

export default InlineSpinner;
